// extracted by mini-css-extract-plugin
export default {"row":"Accordion-module__row__Fd6lZ","icon":"Accordion-module__icon__b5JeF","body":"Accordion-module__body__XP1Uo"};